import blog1 from './../../images/blog-1.jpg';
import blog2 from './../../images/blog-2.jpg';
import blog3 from './../../images/blog-3.jpg';
import blog4 from './../../images/blog-4.jpg';

const blogApi = [
  {
    title: '10 most interesting things you need to know for javascript',
    coverImg: blog1,
    link: 'https://ahsanulkabir.medium.com/10-most-interesting-things-you-need-to-know-for-javascript-5d09868fdf62'
  },
  {
    title: 'Javascript Makeup For Showcase',
    coverImg: blog2,
    link: 'https://ahsanulkabir.medium.com/javascript-makeup-for-showcase-c92ece7ba923'
  },
  {
    title: '12 things you need to know about React',
    coverImg: blog3,
    link: 'https://ahsanulkabir.medium.com/12-things-you-need-to-know-about-react-e1526c39ffc'
  },
  {
    title: 'JavaScript interview question',
    coverImg: blog4,
    link: 'https://ahsanulkabir.medium.com/10-interesting-javascript-interview-questions-and-answers-1c2e0fd60f4f'
  }
]

export default blogApi;